module.exports = __webpack_public_path__ + "static/media/bg.cb6ed1a1.png";